import styled from "styled-components"
import * as variables from "../../../css/variables"

export default styled.div`
.main-textt{
 @media(min-width:${variables.Breakpoints.Laptop}){
  width: auto;
  justify-content:unset;
 margin-bottom:unset;
 margin-left: 40px;
 margin-bottom: 20px;
 }
 display: flex;
 width: 100%;
 justify-content: space-between;
 margin-bottom: 10px;
 margin-right: 3px;
}

.text-title{
 @media(min-width:${variables.Breakpoints.Laptop}){
  font-size: 16px;
 }
 font-family: IRANSans;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.77;
  letter-spacing: normal;
  text-align: right;
  color: #0c0c0c;
}

.text-detail{
 @media(min-width:${variables.Breakpoints.Laptop}){
  font-size: 16px;
  margin-right: 8px;
 }
 font-family: IRANSans;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.77;
  letter-spacing: normal;
  text-align: left;
  color: #00a651;
}

.main-line{
 display: flex;
 flex-direction: row;
 width: 100%;
}

.line{
 @media(min-width:${variables.Breakpoints.Laptop}){
  margin-top: 40px;
  margin-bottom: 40px;
 }
 display: flex;
 height: 1.5px;
 background-color: #8c9da8;
 position: relative;
 margin-top: 20px;
  margin-bottom: 20px;
}


.line-text{
 position:absolute;
 @media(min-width:${variables.Breakpoints.Laptop}){
  font-size: 20px;
  width: 200px;
  right: calc(50% -100px);
 }
 font-family: IRANSans;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #1e4057;
  width: 130px;
  background-color: #f7f6f9;
  right: calc(50% - 65px);
  top: -13px;
}

.main-map-detail{
 display: flex;
 flex-direction: column;
 width: 100%;
}

.map-detail-divv{
 @media(min-width:${variables.Breakpoints.Laptop}){
  flex-direction:row;
  flex-wrap:wrap;
  justify-content:flex-start;
 }
 display: flex;
 flex-direction: column;
 width: 100%;
}

.map-detail-div2{
 @media(min-width:${variables.Breakpoints.Laptop}){
  flex-direction:row;

  flex-wrap:wrap;
  margin-top: 15px;
  margin-bottom: 15px;
 }
 display: flex;
 flex-direction: column;
}

.title{
 @media(min-width:${variables.Breakpoints.Laptop}){
  font-size: 34px;
 }
 width:100%;
 flex-direction: row;
 justify-content: center;
 display: flex;
 font-family: IRANSans;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #0c0c0c;
  margin-right: auto;
  margin-left: auto;
  margin-bottom: 30px;
  /* margin-top: 30px;
  margin-bottom:30px */
}
`